module.exports = __webpack_public_path__ + "static/media/Financial Support pic mobile.c5e16c4e.jpg";